// src/pages/specialx/OverviewSpecialX.jsx

export default function OverviewSpecialX() {
    return (
        <div className="card card--accent">
            <h1>Special Xperience – Overview</h1>
            <p style={{ marginBottom: "18px", fontFamily: "var(--ff-Everett), sans-serif" }}>
                Willkommen bei der Special Xperience.
            </p>
            <p>
                Hier folgen später alle Informationen zu Spezialevents von RaceVision.
            </p>
        </div>
    );
}
